import httpClient from "@hd/http-client/http-client";
import { StartMfaSetupResponse } from "@hd/types/dto/auth/start-mfa-setup.response";

interface Params {
  mfaType: number;
  email?: string;
}
export const startMfaSetupRequest = async (data: Params) => {
  const result = await httpClient.post<StartMfaSetupResponse>(
    import.meta.env.VITE_HD_API_URL + "/auth/start-mfa-setup",
    data,
    {
      // headers: {
      //   [SILENT_REQUEST_HEADER_KEY]: "true",
      // },
    }
  );

  return result.data;
};
